/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';

// components
import CardBase from '../../atoms/CardBase/CardBase';
import Step from './Step/Step';

import NextStep1 from '../../../assets/img/cartita.png'
import NextStep2 from '../../../assets/img/camion-container.png'
import NextStep3 from '../../../assets/img/candado.png'
import NextStep4 from '../../../assets/img/celu-container.png'
import { formatDateToLongSpanish } from '../../../../domain/utils/utilitarios-frontend-coopeuch/rut';
import { formatNamePreserveAccents } from '../../../../domain/utils/utilitarios-frontend-coopeuch/rut';


const CardNextSteps = (props) => {
  /* istanbul ignore next */
  const { email, isMobileDevice, detailData } = props;
  const refNextSteps = useRef(null);
  /* istanbul ignore next */
  const directionData = detailData?.directionDespacho
    ? JSON.parse(detailData.directionDespacho)
    : {};
  /* istanbul ignore next */
  const nextSteps = [
    /* istanbul ignore next */
    {
      name: 'nextStepEmail',
      title: 'Recibirás un email de confirmación',
      icon: NextStep1,
      state: {
        active: true,
        text: '¡Estás aquí!',
      },
      content: (
        <p>
          {' '}
        </p>
      ),
    },
    /* istanbul ignore next */
    {
      name: 'nextStepPassCoopeuch',
      title: `${detailData?.tipoEntrega === "domicilio" ? 'Recibirás tu Tarjeta de Débito' : 'Puedes retirar tu Tarjeta de Débito'}`,
      icon: NextStep2,
      state: {
        active: false,
        text: '',
      },
      /* istanbul ignore next */
      content: (
        <p>
          {detailData?.tipoEntrega === "domicilio"
            ? `El día ${formatDateToLongSpanish(detailData?.dayScheduling || '')} ${detailData?.hourDespacho}, ${[
              directionData?.street,
              directionData?.numeration,
              directionData?.commune,
              directionData?.country
            ]
              .filter(Boolean)
              .join(", ")}.`
            : `Retiro disponible a contar de 3 días hábiles , ${formatNamePreserveAccents(sessionStorage.getItem('commune-preferred-office'))}  ${formatNamePreserveAccents(detailData?.office)}`}
          <br />
          Un(a) ejecutivo(a) se contactará contigo ante cualquier eventualidad
        </p>
      ),
    },
    /* istanbul ignore next */
    {
      name: 'paymentParticipationFees',
      title: 'Crea la clave de tu Tarjeta de Débito',
      icon: NextStep3,
      state: {
        active: false,
        text: '',
      },
      /* istanbul ignore next */
      content: (
        <ol className="orderlist-10gap pl-4">
          <li>
            Al recibir la tarjeta, ingresa a Coopeuch en Línea en el sitio web.
          </li>
          <li>
            Ve al menú “Mis tarjetas”, luego selecciona “Crear clave de tarjeta” y sigue las instrucciones.
          </li>
        </ol>
      ),
    },
    /* istanbul ignore next */
    {
      name: 'paymentParticipationFees',
      title: 'Descarga PassCoopeuch para transacciones seguras',
      icon: NextStep4,
      state: {
        active: false,
        text: '',
      },
      /* istanbul ignore next */
      content: (
        <p>
          Te invitamos a descargar PassCoopeuch desde tu teléfono celular para que puedas autorizar tus
          <br />
          transacciones de forma fácil, rápida y segura.
        </p>
      ),
    },
  ];
  /* istanbul ignore next */
  return (
    <section id="nextStepsComponent" ref={refNextSteps}>
      <CardBase
        title="Próximos pasos"
        subtitle="Es importante que sigas con los pasos detallados a continuación"
        noPadding
        shadedOutline
      >
        <>
          {nextSteps.map((step, index) => {
            return (
              <Step
                key={`step-${index}`}
                step={step}
                position={index + 1}
                isMobileDevice={isMobileDevice}
              />
            );
          })}
        </>
      </CardBase>
    </section>
  );
};
/* istanbul ignore next */
CardNextSteps.defaultProps = {
  email: '',
  isMobileDevice: false,
  /* istanbul ignore next */
  onDownloadComponentPdf: () => null,
};
/* istanbul ignore next */
CardNextSteps.propTypes = {
  email: PropTypes.string,
  isMobileDevice: PropTypes.bool,
  onDownloadComponentPdf: PropTypes.func,
};

export default CardNextSteps;
